import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBroomSparkleCleanBrush = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.2675 9.86104L17.7287 2.05999L16.6436 1.43945L12.0743 9.42956L11.3832 9.17964C9.68821 8.56672 7.98601 9.50402 7.11408 10.8668C6.33366 12.0866 5.29735 12.923 4.03076 13.7619L3.05534 14.408L12.713 18.4486L13.0096 18.1476C14.6116 16.5222 15.4616 15.0858 15.7425 13.0975C15.9426 11.6816 14.981 10.4806 13.7538 10.0369L13.2675 9.86104ZM8.167 11.5405C8.82564 10.5111 9.97205 9.99857 10.9581 10.3551L13.3288 11.2124C14.1276 11.5013 14.6045 12.2173 14.5048 12.9226C14.2877 14.4593 13.6836 15.6084 12.4107 16.9671L9.23324 15.6377L10.0001 13.3337L7.6837 14.9894L5.66417 14.1445C6.61234 13.4366 7.47168 12.6272 8.167 11.5405Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.05588 3.05621L8.75033 1.66732L9.44477 3.05621L10.8337 3.75065L9.44477 4.4451L8.75033 5.83398L8.05588 4.4451L6.66699 3.75065L8.05588 3.05621Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.58366 4.16732L3.61144 6.11176L1.66699 7.08398L3.61144 8.05621L4.58366 10.0007L5.55588 8.05621L7.50033 7.08398L5.55588 6.11176L4.58366 4.16732Z",
			fill: "currentColor"
		})
	]
});
export default SvgBroomSparkleCleanBrush;
